var React = require('react');

function Angle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m32.9 6.21a6.63 6.63 0 0 0-4.69 1.94 6.63 6.63 0 0 0 0 9.37l35.5 35.5-35.5 35.5a6.63 6.63 0 0 0 0 9.37 6.63 6.63 0 0 0 9.37 0l40.1-40.1a6.63 6.63 0 0 0 0.0316-0.031 6.63 6.63 0 0 0 0.0781-0.0797 6.63 6.63 0 0 0-0.0781-9.29l-40.2-40.2a6.63 6.63 0 0 0-4.68-1.94z"}));
}

Angle.defaultProps = {"width":"400","height":"400","version":"1.1","viewBox":"0 0 106 106"};

module.exports = Angle;

Angle.default = Angle;
